import React from "react";
import { Link } from "react-router-dom";

const LandingNav = ({ scrolled, menuOpen, onToggleMenu, onSignIn, onSignUp }) => (
  <nav id="navbar" className={`${scrolled ? "scrolled" : ""}${menuOpen ? " menu-open" : ""}`}>
    <div className="nav-inner">
      <Link to="/" className="nav-logo">
        <img src="/images/logo.png" alt="Ecomdropship" className="nav-logo-img" />
      </Link>
      <ul className="nav-links">
        <li>
          <a href="#how">How it works</a>
        </li>
        <li>
          <a href="#features">Features</a>
        </li>
        <li>
          <a href="#reviews">Reviews</a>
        </li>
        <li>
          <Link to="/best-selling-products?category=all">Product</Link>
        </li>
        <li>
          <Link to="/pricing">Pricing</Link>
        </li>
        <li>
          <a href="#faq">FAQ</a>
        </li>
      </ul>
      <div className="nav-right">
        <button type="button" className="btn-ghost-nav" onClick={onSignIn}>
          Log in
        </button>
        <button type="button" className="btn-orange" onClick={onSignUp}>
          Start free trial
        </button>
      </div>
      <div className="hamburger" id="hamburger" onClick={onToggleMenu} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && onToggleMenu()} aria-label="Toggle menu">
        <span />
        <span />
        <span />
      </div>
    </div>
  </nav>
);

export default LandingNav;
